import { useCallback } from 'react';
import { useMutation } from 'react-query';
import { useSnackbar } from 'notistack';

import {
  printOrderAction,
  Variables,
  ResponseStatus,
} from 'data/requests/historyActions';
import { CDError } from 'utils/error';

const useOrderActions = () => {
  const { enqueueSnackbar } = useSnackbar();

  const { mutateAsync: printOrderMutation, isLoading } = useMutation<
    ResponseStatus,
    CDError,
    Variables
  >(printOrderAction);

  const printOrder = useCallback(
    async ({ orderId }: Variables) => {
      const response = await printOrderMutation({
        orderId,
      });
      enqueueSnackbar(`Order printed`, {
        variant: 'success',
      });
      return response;
    },
    [printOrderMutation, enqueueSnackbar],
  );

  return {
    isLoading,
    printOrder,
  };
};

export default useOrderActions;
